import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDotsHorizontal12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDotsHorizontal12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2M6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2M1 6a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDotsHorizontal12);
